module.exports = __webpack_public_path__ + "img/max1.a6b2e1b1.jpg";